import { useFlowBuilder2PageStore } from '../Store/useFlowBuilder2PageStore';
import { useFindTask } from './useFindTask';

export const useFindActiveTask = () => {
  const activeTaskId = useFlowBuilder2PageStore((s) => s.activeTaskId);
  return useFindTask(activeTaskId ?? '');
};
